/* FASE 3 · movimiento de la home (AX, 2026-09-24). Sin librerías. Con "reducir movimiento" todo queda quieto y visible. */
(function () {
  var root = document.documentElement;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('rh-js');

  var reveal = document.querySelectorAll('[data-rh-reveal], [data-rh-open]');
  if (still || !('IntersectionObserver' in window)) {
    reveal.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    reveal.forEach(function (el) { io.observe(el); });
  }

  var fmt = new Intl.NumberFormat(root.lang || 'es');
  document.querySelectorAll('[data-rh-count]').forEach(function (el) {
    var to = parseInt(el.getAttribute('data-rh-count'), 10);
    if (!to || still || !('IntersectionObserver' in window)) return;
    var done = false;
    var o = new IntersectionObserver(function (entries) {
      if (done || !entries[0].isIntersecting) return;
      done = true; o.disconnect();
      var t0 = performance.now(), dur = 1600;
      (function tick(now) {
        var k = Math.min(1, (now - t0) / dur), ease = 1 - Math.pow(1 - k, 3);
        el.textContent = fmt.format(Math.round(to * ease / 1000) * 1000 || 0);
        if (k < 1) requestAnimationFrame(tick); else el.textContent = fmt.format(to);
      })(t0);
    }, { threshold: 0.6 });
    o.observe(el);
  });

  var vids = document.querySelectorAll('video[data-rh-lazy-video]');
  function startVideo(v) {
    if (v.src || !v.offsetParent) return;
    v.src = v.getAttribute('data-rh-lazy-video');
    if (!still) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
  }
  if ('IntersectionObserver' in window) {
    var vo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) startVideo(e.target); });
    }, { rootMargin: '50% 0px' });
    vids.forEach(function (v) { vo.observe(v); });
  } else { vids.forEach(startVideo); }

  if (still) return;
  var g = document.querySelector('[data-rh-gafas]');
  if (g) (function () {
  var pts = g.querySelectorAll('.rh-g__pt');
  var zoom = g.querySelector('.rh-g__zoom');
  var wide = window.matchMedia('(min-width: 990px)');
  var steps = [0.1, 0.24, 0.38, 0.52, 0.66];
  var ticking = false;
  function update() {
    ticking = false;
    if (!wide.matches) return;
    var r = g.getBoundingClientRect();
    var span = r.height - window.innerHeight;
    var p = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0;
    var cur = -1;
    steps.forEach(function (s, i) { if (p >= s) cur = i; });
    pts.forEach(function (pt, i) {
      pt.classList.toggle('is-on', i <= cur);
      pt.classList.toggle('is-past', i < cur);
    });
    g.classList.toggle('is-moving', p > 0.02);
    g.classList.toggle('is-out', p > 0.33);
    g.classList.toggle('is-end', p >= 0.82);
    var end = p >= 0.82;
    var s = end ? 0.74 : 1 + Math.min(p, 0.8) * 0.1;
    zoom.style.setProperty('--rh-g-s', s.toFixed(3));
    zoom.style.setProperty('--rh-g-y', end ? '-13vh' : '3vh');
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
  })();

  function prog(el) {
    var r = el.getBoundingClientRect(), span = r.height - window.innerHeight;
    return span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0;
  }
  function onFrame(fn) {
    var busy = false;
    function go() { if (!busy) { busy = true; requestAnimationFrame(function () { busy = false; fn(); }); } }
    window.addEventListener('scroll', go, { passive: true });
    window.addEventListener('resize', go);
    fn();
  }

  var tl = document.querySelector('[data-rh-tl]');
  if (tl) (function () {
    var track = tl.querySelector('.rh-t__track'), rail = tl.querySelector('.rh-t__rail');
    var items = tl.querySelectorAll('.rh-t__item'), dist = 0, lastW = 0;
    function size() {
      dist = Math.max(0, track.scrollWidth - document.documentElement.clientWidth);
      tl.style.height = (window.innerHeight + dist) + 'px';
      lastW = window.innerWidth;
    }
    size();
    onFrame(function () {
      if (window.innerWidth !== lastW) size();
      var p = prog(tl), x = -p * dist, vw = document.documentElement.clientWidth;
      var read = vw * (0.3 + 0.65 * p);
      track.style.setProperty('--rh-t-x', x.toFixed(1) + 'px');
      items.forEach(function (it) { it.classList.toggle('is-on', it.offsetLeft + x < read); });
      var f = (read - x - rail.offsetLeft) / rail.offsetWidth;
      rail.style.setProperty('--rh-t-p', Math.min(1, Math.max(0, f)).toFixed(4));
    });
  })();

  var sp = document.querySelector('[data-rh-spec]');
  if (sp) (function () {
    var svg = sp.querySelector('.rh-s__svg'), steps = sp.querySelectorAll('.rh-s__step'), bars = sp.querySelectorAll('.rh-s__bar span');
    onFrame(function () {
      var n = Math.min(3, Math.floor(prog(sp) * 4));
      svg.setAttribute('data-step', n + 1);
      steps.forEach(function (s, i) { s.classList.toggle('is-on', i === n); });
      bars.forEach(function (b, i) { b.classList.toggle('is-on', i <= n); });
    });
  })();
})();
